import { render, staticRenderFns } from "./OfferEvaluationPageCustomerOrderEdit.vue?vue&type=template&id=31a5153e&"
import script from "./OfferEvaluationPageCustomerOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./OfferEvaluationPageCustomerOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a5153e')) {
      api.createRecord('31a5153e', component.options)
    } else {
      api.reload('31a5153e', component.options)
    }
    module.hot.accept("./OfferEvaluationPageCustomerOrderEdit.vue?vue&type=template&id=31a5153e&", function () {
      api.rerender('31a5153e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/OfferEvaluationPageCustomerOrderEdit.vue"
export default component.exports